/**
 * @generated SignedSource<<cc3ad8e62c65a9e808cd72ccc0efee71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type goals_issueFieldGoalsReadviewFull_GoalsReadView$data = {
  readonly selectedGoals: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"popupContent_issueFieldGoalsReadviewFull">;
  } | null | undefined;
  readonly " $fragmentType": "goals_issueFieldGoalsReadviewFull_GoalsReadView";
};
export type goals_issueFieldGoalsReadviewFull_GoalsReadView$key = {
  readonly " $data"?: goals_issueFieldGoalsReadviewFull_GoalsReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"goals_issueFieldGoalsReadviewFull_GoalsReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "popupContent_issueFieldGoalsReadviewFull"
        },
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "key"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedGoals(first:1000)"
    }
  ],
  "type": "JiraGoalsField"
};

(node as any).hash = "13eae32e673f8f11067837df02577e03";

export default node;
